import { render } from "./BrandingLogo.vue?vue&type=template&id=f7983956&scoped=true"
import script from "./BrandingLogo.vue?vue&type=script&lang=js"
export * from "./BrandingLogo.vue?vue&type=script&lang=js"

import "./BrandingLogo.vue?vue&type=style&index=0&id=f7983956&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7983956"]])

export default __exports__